module.exports = "<app-header-dark></app-header-dark>\n<h2 class='text-center'>Coming Soon</h2>\n"